// extracted by mini-css-extract-plugin
export default {"container":"style_container__GCvyz","contentContainer":"style_contentContainer__GQ-PJ"};